import { JsonDynamicFormComponent } from './json-dynamic-form.component';
import { InjectionToken } from '@angular/core';

export const JsonDynamicFormToken =
  new InjectionToken<JsonDynamicFormComponent>(
    'Injection token for Json Dynamic Component',
  );

export const EXTERNAL_CONFIG = new InjectionToken<any>(
  'External Configuration',
);
